//C:\xampp\htdocs\pms\frontend\src\App.tsx
/*import "bootstrap/dist/css/bootstrap.min.css";
import HomePage from "./pages/HomePage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

<ToastContainer position="top-right" autoClose={2500} />

export default function App() {
  return <HomePage />;
}*/

// src/App.tsx
// src/App.tsx
/* 
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProductList from "./components/products/ProductList";
import BarcodeScanner from "./components/BarcodeScanner";
import Reports from "./pages/Reports";
import AdminPanel from "./pages/AdminPanel";
import Login from "./pages/Login";

export default function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />

        {// Product search page for desktop /}
        <Route
          path="/product-search"
          element={<ProductList cart={[]} setCart={() => {}} />}
        />

        {/ Barcode scanner page for mobile /}
        <Route
          path="/barcode-scanner"
          element={<BarcodeScanner onDetected={(code) => console.log(code)} />}
        />

        {/ Other routes /}
        <Route
          path="/products"
          element={<ProductList cart={[]} setCart={() => {}} />}
        />
        <Route path="/reports" element={<Reports />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/login" element={<Login />} />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
    </>
  );
}
*/


import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ProductSearch from "./components/ProductSearch";
import BarcodeScanner from "./components/BarcodeScanner";
//import ProductList from "./components/products/ProductList";
import ProductInfo from "./components/ProductInfo";
import BarcodeScannerPage from "./pages/BarcodeScannerPage";

import Pos from "./pages/Pos";


export default function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<HomePage />} />

      {/* Desktop search by name */}
      <Route path="/product-search" element={<ProductSearch />} />
      <Route path="/pos" element={<Pos />} />
      {/* Mobile scan by barcode */}
        <Route path="/barcode-scanner" element={<BarcodeScannerPage />} />
    </Routes>
    <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      </>
  );
}

//Original code
//export default App; 
/*
import { useState } from 'react'
import reactLogo from './assets/react.svg'
import viteLogo from '/vite.svg'
import './App.css'

function App() {
  const [count, setCount] = useState(0)

  return (
    <>
      <div>
        <a href="https://vite.dev" target="_blank">
          <img src={viteLogo} className="logo" alt="Vite logo" />
        </a>
        <a href="https://react.dev" target="_blank">
          <img src={reactLogo} className="logo react" alt="React logo" />
        </a>
      </div>
      <h1>Vite + React</h1>
      <div className="card">
        <button onClick={() => setCount((count) => count + 1)}>
          count is {count}
        </button>
        <p>
          Edit <code>src/App.tsx</code> and save to test HMR
        </p>
      </div>
      <p className="read-the-docs">
        Click on the Vite and React logos to learn more
      </p>
      <div>
      <ProductList /></div>
    </>
  )
}

export default App */
